var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYearlyPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 0H12C5.37258 0 0 5.37258 0 12V64C0 70.6274 5.37258 76 12 76H64C70.6274 76 76 70.6274 76 64V12C76 5.37258 70.6274 0 64 0Z",
    fill: "#553C9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M64 0C70.63 0 76 5.37 76 12V42C52.8 42 34 23.2 34 0H64Z",
    fill: "#D6BCFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 46H26C28.21 46 30 47.79 30 50V76H12C5.37 76 0 70.63 0 64V46Z",
    fill: "#D6BCFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearlyPlan);
export default __webpack_public_path__ + "static/media/YearlyPlan.bda590f7d4ee2cd23c64477861f94733.svg";
export { ForwardRef as ReactComponent };